var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', [_c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section'),
      "meta": _vm.meta
    }
  }), _vm.page === 'redeem' ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm.editable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.redeemCode,
      expression: "redeemCode"
    }],
    staticClass: "redeem__input field__input",
    attrs: {
      "placeholder": "請輸入序號"
    },
    domProps: {
      "value": _vm.redeemCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.redeemCode = $event.target.value;
      }
    }
  }) : _c('div', {
    staticClass: "redeem"
  }, [_c('span', {
    staticClass: "redeem__code"
  }, [_vm._v(_vm._s(_vm.redeemCode))])]), _c('div', {
    staticClass: "card__divider"
  }), _c('div', {
    staticClass: "card__info"
  }, [_vm.event ? [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.redeemTitle))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.redeemMessage)
    }
  })] : _vm._e()], 2)]), _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.redeem();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.event.config['redeem_button_text']) + " ")])])]) : _vm._e(), _vm.page === 'form' ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_vm.formMessage ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formMessage)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form"
  }, _vm._l(_vm.fields.filter(function (x) {
    return x.hidden == undefined || !x.hidden;
  }), function (field, index) {
    return _c('div', {
      key: "field.".concat(index),
      staticClass: "field"
    }, [field.type === 'select' && field.matched_key && !field.provider ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('SharedSelect', {
      attrs: {
        "options": field.options,
        "hasBorder": false,
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key), $$v);
        },
        expression: "form[`${field.field_key}`]"
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()], 1) : field.type === 'radio' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "s-flex flex-wrap",
      class: field.is_vertical && 'flex-column'
    }, _vm._l(field.options, function (option, index) {
      return _c('SharedRadioButton', {
        key: field.title + index,
        attrs: {
          "id": field.title + index,
          "value": option.value,
          "name": field.matched_key,
          "disabled": field.disabled
        },
        model: {
          value: _vm.form["".concat(field.field_key)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, "".concat(field.field_key), $$v);
          },
          expression: "form[`${field.field_key}`]"
        }
      }, [_vm._v(" " + _vm._s(option.text) + " ")]);
    }), 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : field.type === 'checkbox' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "s-flex"
    }, [_c('b-form-checkbox-group', {
      attrs: {
        "options": field.options,
        "stacked": field.is_vertical,
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key), $$v);
        },
        expression: "form[`${field.field_key}`]"
      }
    })], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.field_key],
        expression: "form[field.field_key]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form[field.field_key].$error
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form[field.field_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.field_key, $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e()]);
  }), 0)])]), _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.submitForm();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.event.config['form_button_text']) + " ")])])]) : _vm._e(), ['no_gift', 'already_joined', 'success', 'expired'].includes(_vm.page) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(" " + _vm._s(_vm.statusTitle) + " ")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.statusMessage)
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "fixed-footer",
    domProps: {
      "innerHTML": _vm._s(this.event.config['warnning_message'])
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }